module.exports = __webpack_public_path__ + "img/left-arm_active.716f5298.png";